var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/plus.9c8a1ff0.png","uri@2x": __webpack_public_path__ + "static/media/plus.7d7b6daa.png","uri@3x": __webpack_public_path__ + "static/media/plus.1dd9659a.png",
    width: 16,
    height: 16
});